import Vue from 'vue';
import App from './App.vue';
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router';
import http from './http';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import common from './common/function'
import 'swiper/swiper-bundle.css'
import store from './store'
import VueI18n from 'vue-i18n';
import { readSavedLanguageOption } from '@/common/languages';

import 'video.js/dist/video-js.css'
import { Locale } from 'vant';

const ynYu = require('./assets/languages/yn_yu.json');
const zhCn = require('./assets/languages/zh_cn.json');
const zhTw = require('./assets/languages/zh_tw.json');
const enUs = require('./assets/languages/en_us.json');
const esSpa = require('./assets/languages/es_spa.json');
const msMy = require('./assets/languages/ms_my.json');
const idnYu = require('./assets/languages/idn_yu.json');
const koHy = require('./assets/languages/ko_hy.json');

const koVant = (koHy && koHy.vant) || {};

Locale.use('ko-KR', {
  name: koVant.name,
  tel: koVant.tel,
  save: koVant.save,
  confirm: koVant.confirm,
  cancel: koVant.cancel,
  delete: koVant.delete,
  complete: koVant.complete,
  loading: koVant.loading,
  telEmpty: koVant.telEmpty,
  nameEmpty: koVant.nameEmpty,
  nameInvalid: koVant.nameInvalid,
  confirmDelete: koVant.confirmDelete,
  telInvalid: koVant.telInvalid,
  vanCalendar: {
    ...(koVant.vanCalendar || {}),
    monthTitle: (year, month) =>
      ((koVant.vanCalendar && koVant.vanCalendar.monthTitleTemplate) || '{year}년{month}월')
        .replace('{year}', year)
        .replace('{month}', month),
    rangePrompt: (maxRange) =>
      ((koVant.vanCalendar && koVant.vanCalendar.rangePromptTemplate) || '선택한 일수는 {maxRange} 일을, 초과할 수 없습니다')
        .replace('{maxRange}', maxRange),
  },
  vanCascader: {
    ...(koVant.vanCascader || {}),
  },
  vanContactCard: {
    ...(koVant.vanContactCard || {}),
  },
  vanContactList: {
    ...(koVant.vanContactList || {}),
  },
  vanPagination: {
    ...(koVant.vanPagination || {}),
  },
  vanPullRefresh: {
    ...(koVant.vanPullRefresh || {}),
  },
  vanSubmitBar: {
    ...(koVant.vanSubmitBar || {}),
  },
  vanCoupon: {
    ...(koVant.vanCoupon || {}),
    discount: (discount) =>
      ((koVant.vanCoupon && koVant.vanCoupon.discountTemplate) || '{discount}할인')
        .replace('{discount}', discount),
    condition: (condition) =>
      ((koVant.vanCoupon && koVant.vanCoupon.conditionTemplate) || '{condition}원 이상 시 사용 가능.')
        .replace('{condition}', condition),
  },
  vanCouponCell: {
    ...(koVant.vanCouponCell || {}),
    count: (count) =>
      ((koVant.vanCouponCell && koVant.vanCouponCell.countTemplate) || '{count}장 사용가능')
        .replace('{count}', count),
  },
  vanCouponList: {
    ...(koVant.vanCouponList || {}),
  },
  vanAddressEdit: {
    ...(koVant.vanAddressEdit || {}),
  },
  vanAddressEditDetail: {
    ...(koVant.vanAddressEditDetail || {}),
  },
  vanAddressList: {
    ...(koVant.vanAddressList || {}),
  },
});

Vue.prototype.$http = http
Vue.prototype.common = common
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(Vant);
Vue.use(VueI18n);

const savedLanguage = readSavedLanguageOption();
const locale = savedLanguage.appLang || localStorage.getItem('lang') || 'zh_cn';
localStorage.setItem('lang', locale);
localStorage.setItem('login_display_lang', savedLanguage.code || locale);
localStorage.setItem('displayLang', savedLanguage.code || locale);
const i18n = new VueI18n({
  globalInjection: true, 
  locale,
  messages: {
    'yn_yu': ynYu,
    'zh_cn': zhCn,
    'zh_tw': zhTw,
    'en_us': enUs,
    'es_spa': esSpa,
    'ms_my': msMy,
    'idn_yu': idnYu,
    'ko_hy': koHy,
  }
});

function updateDocumentTitle(route) {
  const currentRoute = route || router.currentRoute;
  const matchedRoute = currentRoute && currentRoute.matched && currentRoute.matched[0];
  const titleKey = matchedRoute && matchedRoute.meta && matchedRoute.meta.titleKey;
  document.title = titleKey ? i18n.t(titleKey) : 'OMN';
}

router.afterEach((to) => {
  updateDocumentTitle(to);
});

if (i18n && i18n.vm) {
  i18n.vm.$watch('locale', () => {
    updateDocumentTitle();
  });
}

updateDocumentTitle(router.currentRoute);

new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
